import {
  Menu as MenuComponent,
  Button as ButtonComponent,
} from '@material-ui/core';
import * as lib from '~/dependencies';

export const Container = lib.styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
`;

export const Button = lib.styled(ButtonComponent)`
  &.MuiButton-root {
    text-transform: none;
  }

  span {
    margin-left: 3px;
  }
`;

export const Menu = lib.styled(MenuComponent)`
  & .MuiMenuItem-root {
    font-size: 14px;
  }

  & .MuiMenu-paper {
    top: 70px!important;
  }

  & .MuiList-padding {
    padding: 0;
  }
`;
